import _core from "./core.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineAsCustomElements = void 0;
const core_js_1 = _core;

const defineAsCustomElementsSSR = (component, componentName, _publicProps = [], _options = {}) => {
  if (!/^[a-zA-Z0-9]+-[a-zA-Z0-9]+$/.test(componentName)) console.log(`Error: WebComponent name "${componentName}" is invalid.`);else _nano.customElements.set(componentName, component);
};

const defineAsCustomElements = function (component, componentName, publicProps, {
  mode = "closed",
  delegatesFocus = false
} = {}) {
  if ((0, core_js_1.isSSR)()) {
    defineAsCustomElementsSSR(component, componentName, publicProps);
    return;
  }

  customElements.define(componentName, class extends HTMLElement {
    constructor() {
      super();
      const shadowRoot = this.attachShadow({
        mode,
        delegatesFocus
      });
      let ref;
      const children = Array.from(this.children).map(c => (0, core_js_1.render)(c)); // because nano-jsx update need parentElement, so DocumentFragment is not usable...

      const el = (0, core_js_1.h)("div", null, (0, core_js_1._render)({
        component,
        props: {
          children: children,
          ref: r => ref = r
        }
      }));
      this.component = ref;
      this.isFunctionalComponent = !component.isClass;
      this.functionalComponentsProps = {};
      shadowRoot.append(el);

      if (!this.isFunctionalComponent) {
        this.component.updatePropsValue = (name, value) => {
          // @ts-ignore
          if (!this.component.props) this.component.props = {};
          this.component.props[name] = value;
          this.component[name] = value;
        };
      }
    }

    static get observedAttributes() {
      return publicProps;
    }

    removeChildren() {
      var _a;

      if (this.shadowRoot) {
        const children = Array.from((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.children) || [];

        for (const el of children) {
          el.remove();
        }
      }
    }

    attributeChangedCallback(name, _, newValue) {
      if (!this.isFunctionalComponent) {
        this.component.updatePropsValue(name, newValue);
        this.component.update();
      } else {
        this.removeChildren();
        this.functionalComponentsProps[name] = newValue;
        const el = (0, core_js_1.h)("div", null, (0, core_js_1._render)({
          component,
          props: Object.assign({
            children: [],
            ref: r => this.component = r
          }, this.functionalComponentsProps)
        }));
        this.shadowRoot.append(el);
      }
    }

  });
};

exports.defineAsCustomElements = defineAsCustomElements; //# sourceMappingURL=customElementsMode.js.map

export default exports;